import React, { Suspense, lazy, useCallback, useState } from "react";
import { createPortal } from "react-dom";
import userFloat from "../../assets/images/Tec1.png";
import RetractableFloatingLauncher from "./ui/RetractableFloatingLauncher";

// El chat solo se descarga cuando alguien lo abre.
const TecChat = lazy(() => import("./tec/TecChat"));

const FloatingUserButton: React.FC = () => {
  const [open, setOpen] = useState(false);

  const handleAction = useCallback(() => setOpen((o) => !o), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <>
      <RetractableFloatingLauncher
        variant="tec"
        ariaLabelExpand="Expandir asistente TEC"
        ariaLabelAction={open ? "Cerrar asistente TEC" : "Hablar con TEC"}
        ariaLabelRetract="Retraer asistente TEC"
        onAction={handleAction}
        bubble={
          open ? undefined : (
            <>
              ¿Te sientes perdido? <strong>Hablemos</strong>
            </>
          )
        }
      >
        <img
          src={userFloat}
          alt=""
          className="rf-launcher__logo"
          aria-hidden="true"
        />
      </RetractableFloatingLauncher>
      {open &&
        createPortal(
          <Suspense fallback={null}>
            <TecChat onClose={close} />
          </Suspense>,
          document.body,
        )}
    </>
  );
};

export default FloatingUserButton;
